/* Modal */

// NPM package Moodal
import 'modaal';

// Modaal Basic
export function axModaalBasic( selector ) {
	const jQuery = window.jQuery;

	if ( jQuery( selector ).length ) {
		jQuery( selector ).modaal();
	}
}

// Modaal Ajax
export function axModaalAjax( selector ) {
	const jQuery = window.jQuery;

	if ( jQuery( selector ).length ) {
		if ( jQuery( selector ).attr( 'href' ) ) {
			jQuery( selector ).modaal( {
				type: 'ajax',
				loading_content: `<div class="ax-modal-loading-content"><div class="ax-loader"></div></div>`,
				width: 1030,
			} );
		} else {
			const childWithHref = jQuery( selector ).find( '[href]:first' );
			if ( childWithHref.length ) {
				// Do something with the child element that has an href attribute
				jQuery( childWithHref ).modaal( {
					type: 'ajax',
					loading_content: `<div class="ax-modal-loading-content"><div class="ax-loader"></div></div>`,
					width: 1030,
				} );
			}
		}
	}
}

// Modaal Video
export function axModaalVideo( selector ) {
	const jQuery = window.jQuery;

	if ( jQuery( selector ).length ) {
		jQuery( selector ).modaal( {
			type: 'video',
		} );
	}
}

// Modaal Inline
export function axModaalInline( selector ) {
	const jQuery = window.jQuery;

	if ( jQuery( selector ).length ) {
		jQuery( selector ).modaal( {
			animation: 'fade',
			loading_content: `<div class="ax-modal-loading-content"><div class="ax-loader"></div></div>`,
		} );
	}
}
